import React from 'react';
import QrScanner from 'qr-scanner';
import { Button, Card, CardBody } from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";


function Scan() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [cameraPosition, setCameraPosition] = React.useState('environment');
  let backEndUrl = localStorage.getItem("be");
  let scanner = null;
  // const [data, setData] = useState('No result');
  function processScannedData (data){
    let qrDataText = data.data;
    qrDataText = qrDataText.replace(/(\r\n|\n|\t|\r)/gm, "");
    if (qrDataText.indexOf("deviceId") > -1) {
      let qrData = JSON.parse(qrDataText);
      if(qrData.deviceId) {
        sendQR4Validation(qrData);
        scanner.stop();
      } else {
        console.log("Invalid QR scanned");
      }
    } else {
      alert("Invalid QR scanned");
      scanner.stop();
    }
  }

  const sendQR4Validation = async (data) => {
    console.log("sendQR4Validation called");
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + state.token);
    let raw = JSON.stringify(data);

    var requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      body: raw
    };

    await fetch(backEndUrl + "api/customer/usesitting/" + state.phone , requestOptions)
      .then(response => response.text())
      .then(result => {
        let userData = JSON.parse(result);
        if(userData.message) {
          alert(userData.message);
          scanner.stop();
        } else {
          navigate("/success");
        }
      })
      .catch(error => {
        console.log('error', error);
        alert(error);
        scanner.stop();
      });
  }

  function initiateQr () {
    console.log("Working");
      scanner = new QrScanner(
      document.getElementById("vid"),
      result => {
        processScannedData(result)
      }, {preferredCamera : 'environment'}
      // No options provided. This will use the old api and is deprecated in the current version until next major version.
    );
    //scanner.setCamera("user");
    scanner.start();
  }

  function rotateCamera() {
    if(cameraPosition === "user") {
      setCameraPosition("environment");
      scanner.setCamera("environment");
    } else {
      setCameraPosition("user");
      scanner.setCamera("user");
    }
  }

  function logout() {
    navigate("/");
  }
  

  return (
    <Card
        color="dark"
        style={{width: '20rem' ,height: "70vh", margin: "0 auto", marginTop: "16vh"}}>
        <img
          alt="Zero Gravity"
          src="https://atzerogravity.com/wp-content/uploads/2021/11/ZG_Logo_web.png" />
        <CardBody>
          <div className="Scan" style={{width: '100%', height:"80%"}}>
            <video id="vid" style={{width: '100%', height:"85%"}}>
 
            </video>
            <Button color="light" onClick={initiateQr} style={{float: "left"}}>Scan QR</Button>
            <Button color="light" onClick={rotateCamera} style={{float: "right"}}>Flip Camera</Button>
            <Button color="light" onClick={logout} style={{marginTop: "20px", width: "100%"}}>Logout</Button>

            {/* <QrReader
              onResult={(result, error) => {
                if (!!result) {
                  processScannedData(result?.text);
                }

                // if(!!error) {
                //   console.log(error);
                // }
              }}
              style={{ width: '100%' }}
            /> */}
          </div>
        </CardBody>
      </Card>


  );
}

export default Scan;
